
import { initializeApp, FirebaseApp } from "firebase/app";
import { getFirestore, Firestore, initializeFirestore, FirestoreSettings } from "firebase/firestore";
import { getAuth, Auth } from "firebase/auth";
import { getFunctions, Functions } from "firebase/functions";
import { getMessaging, Messaging } from "firebase/messaging";
import { getAnalytics, Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID
};


// initialize firebase app
const app: FirebaseApp = initializeApp(firebaseConfig);

/*
// determine environment and set database ID accordingly
const isLocalhost = window.location.hostname === 'localhost';
const databaseId = isLocalhost ? process.env.REACT_APP_DEV_DATABASE_ID : undefined;

// log database being used
console.log(`Using Firestore database ID: ${databaseId ? databaseId : 'default'}`);

// initialize firestore with appropriate database ID
let firestore: Firestore;
if (databaseId) {
  // Initialize Firestore with the specific database ID for development
  firestore = initializeFirestore(app, {
    experimentalForceLongPolling: true
  }, databaseId);
} else {
  // initialize firestore with the default database
  firestore = getFirestore(app);
}
*/


const auth: Auth = getAuth(app);
const functions: Functions = getFunctions(app);
const messaging: Messaging = getMessaging(app);
const analytics: Analytics = getAnalytics(app);
const firestore: Firestore = getFirestore(app)

export { app, auth, firestore, functions, messaging, analytics };